import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const FilterButton = ({ data, setAction, type, activePeriod }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [localVariables, setLocalVariables] = useState([]);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (rect) {
      setPosition({ top: rect.top, left: rect.left });
    }
  }, []); // Run only once after mount

  return (
    <Container>
      <Button
        $isDropdownVisible={showDropdown}
        ref={buttonRef}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <span>{t(`settings.${type}`)}</span>
      </Button>

      {showDropdown &&
        createPortal(
          <Dropdown
            $top={position.top}
            $left={position.left}
            ref={dropdownRef} // <-- Attach dropdown ref
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Title>{t(`settings.select_${type}`)}</Title>
            </div>
            <DropdownList $type={type} $listSize={data?.length < 8}>
              {data?.map((item, id) => {
                return type === "subsystem" || type === "station" ? (
                  <ListItem
                    onClick={() => {
                      setAction(item.id ?? item.mysensor_id);
                      setShowDropdown(false);
                    }}
                    key={`${type}_list_item_${id}`}
                    to={`/map?typeId=${item.id}`}
                  >
                    {item.title}
                  </ListItem>
                ) : (
                  <CheckboxItem
                    $isItemIncluded={
                      type === "period"
                        ? `${item.id}` === activePeriod
                        : localVariables.includes(item.title)
                    }
                    key={`${type}_checkbox_${id}`}
                    onClick={() => {
                      if (type === "period") {
                        setAction(item.id);
                        setShowDropdown(false);
                      } else {
                        if (localVariables.includes(item.title)) {
                          setLocalVariables(
                            localVariables.filter(
                              (varItem) => varItem !== item.title
                            )
                          );
                        } else {
                          setLocalVariables([...localVariables, item.title]);
                        }
                      }
                    }}
                  >
                    {item.title}
                  </CheckboxItem>
                );
              })}
              {type === "variable" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <ConfirmationButton
                    onClick={(event) => {
                      setShowDropdown(false);
                    }}
                  >
                    Ακύρωση
                  </ConfirmationButton>
                  <ConfirmationButton
                    onClick={() => {
                      setAction(localVariables);
                      setShowDropdown(false);
                    }}
                    $isConfirmation={true}
                  >
                    Εφαρμογη
                  </ConfirmationButton>
                </div>
              )}
            </DropdownList>
          </Dropdown>,
          document.body
        )}
    </Container>
  );
};

export default FilterButton;
const Container = styled.div`
  position: relative;
`;

const Button = styled.div`
  width: 148px;
  height: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${({ $isDropdownVisible }) =>
    $isDropdownVisible ? "#ddd" : "transparent"};
  font-weight: ${({ $isDropdownVisible }) =>
    $isDropdownVisible ? "600" : "500"};

  border: 1px solid #cccccc4f;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #ddd;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    font-weight: 600;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  max-height: 500px;
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top + 40}px;
  padding: 20px 30px;
  background-color: #fff;
  z-index: 600;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
`;

//   max-height: ${({ $type, $listSize }) =>
//     $type === "subsystem" ? "300px" : $listSize ? "200px" : "440px"};
const DropdownList = styled.div`
  max-width: 860px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-wrap: wrap;
`;

const ListItem = styled.p`
  color: #333;
  padding: 8px 10px;
  transition: all 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
    background-color: #3333331f;
    transition: all 0.3s ease-in-out;
    border-radius: 8px;
  }
`;

const CheckboxItem = styled.label`
  color: #333;
  padding: 8px 4px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding-inline: 10px;
  border-radius: 8px;
  background-color: ${({ $isItemIncluded }) =>
    $isItemIncluded ? "#3333331f" : "transparent"};
  &:hover {
    background-color: #3333334f;
    transition: all 0.3s ease-in-out;
    border-radius: 8px;
    // padding-left: 14px;
  }
`;

const Title = styled.div`
  color: darkgray;
`;

const ConfirmationButton = styled.button`
  width: 110px;
  height: 30px;
  border-radius: 6px;
  background-color: ${({ $isConfirmation }) =>
    $isConfirmation ? "#0000ff8f" : "#aaaaaa1f"};
  color: ${({ $isConfirmation }) => ($isConfirmation ? "#ffe" : "#333")};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ $isConfirmation }) =>
      $isConfirmation ? "#00f" : "#aaaaaa8f"};
    color: ${({ $isConfirmation }) => ($isConfirmation ? "#fff" : "#000")};
    transition: all 0.3s ease-in-out;
  }
`;
